// @ts-nocheck
import { useState, useEffect } from 'react';
import Http from 'services/http2';
import CompanyService from 'services/company2';
import EnumService from 'services/enum2';
import User from 'services/user2';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { TextField, Button } from '@material-ui/core';
import { useForm, Controller } from 'react-hook-form';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import dayjs from 'dayjs';
/**
 * 请购单单头编辑组件
 *
 */
function DialogEditRequisiton(props) {
  const { isNew, detail, open, onComplete, onClose, companyCode } = props;

  const [purCompanyList, setPurCompanyList] = useState([]); // 请购公司列表
  const [sourceTypeList, setSourceTypeList] = useState([]); // 来源类型列表
  const [receivePlaceList, setReceivePlaceList] = useState([]); // 收货地点列表
  const [purOrgList, setPurOrgList] = useState([]); // 采购组织列表
  const [reqInnerTypeList, setReqInnerTypeList] = useState([]); // 请购类型列表
  const [purCompanyCode, setPurCompanyCode] = useState(''); // 请购公司
  const [erpOrgCode, setErpOrgCode] = useState(''); // 采购组织
  const [receivePlaceCode, setReceivePlaceCode] = useState(''); // 收货地点
  const [reqInnerTypeCode, setReqInnerTypeCode] = useState(''); // 请购类型
  const [sourceType, setSourceType] = useState(''); // 来源类型
  const [isInit, setIsInit] = useState(false);

  const { register, setValue, handleSubmit } = useForm();

  useEffect(() => {
    if (open) {
      init();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, !isInit, detail, companyCode]);

  // 请购公司改变
  useEffect(() => {
    if (open && purCompanyCode) {
      // 获取采购组织列表
      getPurchaseOrgList();
      // 获取收货地点
      getReceivePlaceList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, purCompanyCode]);

  // 初始化
  async function init() {
    if (isInit || !companyCode) {
      return;
    }

    // 更新状态
    setPurCompanyCode(detail.purCompanyCode);
    setErpOrgCode(detail.erpOrgCode);
    setReceivePlaceCode(detail.receivePlaceCode);
    setReqInnerTypeCode(detail.reqInnerTypeCode);
    setSourceType(detail.sourceType);

    // 设置默认值
    setValue('purCompanyCode', detail.purCompanyCode);
    setValue('erpOrgCode', detail.erpOrgCode);
    setValue('receivePlaceCode', detail.receivePlaceCode);
    setValue('reqInnerTypeCode', detail.reqInnerTypeCode);
    setValue('sourceType', detail.sourceType);
    setValue('reqDate', formatDate(detail.reqDate || Date.now()));

    // 请购类型列表
    let list = await CompanyService.getCompEnumList(
      companyCode,
      'B2b_Requisition_Type',
      true
    );
    setReqInnerTypeList(list);

    // 来源类型列表
    let arr = await EnumService.getItems('B01_Req_Source_Type');
    setSourceTypeList(arr);

    // 获取请购公司列表
    getCompanyList();

    setIsInit(true);
  }

  // 获取采购组织列表
  async function getPurchaseOrgList() {
    if (!purCompanyCode) {
      return;
    }
    //是否开启采购组织
    let isOpenOrg = await CompanyService.checkOpenOrg(purCompanyCode);

    if (isOpenOrg) {
      let arr = await CompanyService.getPurchaseOrgList(purCompanyCode);
      setPurOrgList(arr);

      // if (this.purOrgList.length > 0 && this.detail.erpOrgCode) {
      //   this.getProfitCenterFormOrg();
      // } else if (this.purOrgList.length === 0 || !this.detail.erpOrgCode) {
      //   this.getProfitCenterFormCompany();
      // }
    }
  }

  // 获取收货地点
  async function getReceivePlaceList() {
    if (purCompanyCode) {
      let arr = await CompanyService.getDeliveryAddressList(purCompanyCode);
      setReceivePlaceList(arr);
    }
  }

  // 获取请购公司列表
  function getCompanyList() {
    // 采购公司
    CompanyService.getCompRelationList(companyCode).then(data => {
      let list = [],
        vendorList = User.getCompanyList();
      data.forEach(item => {
        vendorList.forEach(row => {
          if (row.companyCode === item.id) {
            list.push({ id: row.companyCode, text: row.companyName });
          }
        });
      });
      list.unshift({
        id: companyCode,
        text: '本公司'
      });
      setPurCompanyList(list);

      // if (this.isNew) {
      //   this.detail['purCompanyCode'] = this.companyCode;
      //   this.detail['purCompanyName'] = this.translatePack['BASE.THE_COMPANY'];
      //   this.getIsOpenOrg();
      //   this.getReqList();
      //   this.getReceivePlaceList();
      //   this.getIsOpenProfit(); //获取是否开启工厂
      // }
    });
  }

  function sourceTypeChange(event) {
    detail.sourceType = Number(event.target.value);
    setSourceType(event.target.value);
    // this.getOrderNoList();
  }

  /**
   * 获取枚举字段name
   *
   * @param code
   * @param list
   * @param [nameField] name字段，默认为 'text'
   * @returns
   */
  function getNameByCode(code, list, nameField = 'text') {
    for (let item of list) {
      if (code === item.id) {
        return item[nameField];
      }
    }
    return '';
  }

  // 确认
  function ok(formData) {
    formData.purCompanyName = getNameByCode(
      formData.purCompanyCode,
      purCompanyList,
      'text'
    );

    formData.erpOrgName = getNameByCode(
      formData.erpOrgCode,
      purOrgList,
      'name'
    );

    formData.reqInnerTypeName = getNameByCode(
      formData.reqInnerTypeCode,
      reqInnerTypeList,
      'subValue'
    );

    formData.receivePlaceName = getNameByCode(
      formData.receivePlaceCode,
      receivePlaceList,
      'text'
    );

    formData.reqDate = dayjs(formData.reqDate).valueOf();

    if (typeof onComplete === 'function') {
      Object.assign(detail, formData);
      onComplete(formData);
    }
    close();
  }

  // 关闭
  function close() {
    if (typeof onClose === 'function') {
      onClose();
    }
  }

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={close}
      aria-labelledby="form-dialog-title"
    >
      <form onSubmit={handleSubmit(ok)}>
        {/* {isNew && <h3>新建请购</h3>} */}
        <DialogTitle id="form-dialog-title">基础信息</DialogTitle>
        <DialogContent className="mui-dialog-content">
          <span>
            <div className="form-item">
              <p className="form-item-name">请购公司</p>
              <select
                value={purCompanyCode}
                {...register('purCompanyCode', {
                  onChange: e => {
                    setPurCompanyCode(e.target.value);
                    // 清除采购组织
                    setValue('erpOrgCode', '');
                    setPurOrgList([]);
                    // 清除收货地点
                    setValue('receivePlaceCode', '');
                    setReceivePlaceList([]);
                  }
                })}
              >
                <option key={0} value={''}>
                  {'--请选择--'}
                </option>
                {purCompanyList.map((row, j) => (
                  <option key={j} value={row.id}>
                    {row.text}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-item">
              <p className="form-item-name">采购组织</p>
              <select
                value={erpOrgCode}
                {...register('erpOrgCode', {
                  onChange: e => {
                    setErpOrgCode(e.target.value);
                  }
                })}
              >
                <option key={0} value={''}>
                  {'--请选择--'}
                </option>
                {purOrgList.map((row, j) => (
                  <option key={j} value={row.id}>
                    {row.text}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-item">
              <p className="form-item-name">请购类型</p>
              <select
                value={reqInnerTypeCode}
                {...register('reqInnerTypeCode', {
                  onChange: e => {
                    setReqInnerTypeCode(e.target.value);
                  }
                })}
              >
                <option key={0} value={''}>
                  {'--请选择--'}
                </option>
                {reqInnerTypeList.map((row, j) => (
                  <option key={j} value={row.id}>
                    {row.text}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-item">
              <p className="form-item-name">来源类型</p>
              <select
                value={sourceType}
                {...register('sourceType', {
                  onChange: sourceTypeChange
                })}
              >
                <option key={0} value={''}>
                  {'--请选择--'}
                </option>
                {sourceTypeList.map((row, j) => (
                  <option key={j} value={row.id}>
                    {row.text}
                  </option>
                ))}
              </select>
            </div>
          </span>
          <div className="form-item">
            <p className="form-item-name">收货地点</p>
            <select
              value={receivePlaceCode}
              {...register('receivePlaceCode', {
                onChange: e => {
                  setReceivePlaceCode(e.target.value);
                }
              })}
            >
              <option key={0} value={''}>
                {'--请选择--'}
              </option>
              {receivePlaceList.map((row, j) => (
                <option key={j} value={row.id}>
                  {row.text}
                </option>
              ))}
            </select>
          </div>
          <div className="form-item">
            <p className="form-item-name">请购日期</p>
            <input
              type="date"
              {...register('reqDate', {
                onChange: e => {}
              })}
            />
          </div>
        </DialogContent>
        <DialogActions className="dialog-sticky-actions">
          <Button onClick={close} variant="contained">
            取消
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className="mui-btn-primary"
          >
            确认
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default DialogEditRequisiton;
